import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { IWorkExperience } from '../../../../../interfaces/user-work-experience.interface';
import { WorkExperienceFormInputs } from '../WorkExperience';
import SquareCheckboxIcon from '../../../../Profile/SquareCheckbox/SquareCheckboxIcon';

type WorkExperienceBooleanKeys = {
  [K in keyof IWorkExperience]: IWorkExperience[K] extends boolean ? K : never;
}[keyof IWorkExperience];

interface CheckBoxProps {
  name: `workExperiences.${number}.${WorkExperienceBooleanKeys}`;
  label: string;
  control: Control<WorkExperienceFormInputs, any>;
  onFieldChange?: (field: keyof IWorkExperience, value: any) => void;
}

const CheckBox = ({ name, label, control, onFieldChange }: CheckBoxProps) => {
  return (
    <Controller
      name={name as keyof WorkExperienceFormInputs}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Checkbox
              checked={!!field.value}
              onChange={(e, checked) => {
                field.onChange(checked);
                onFieldChange?.(name as keyof IWorkExperience, checked);
              }}
              sx={{
                padding: 0,
                margin: 0,
              }}
              icon={<SquareCheckboxIcon />}
              checkedIcon={<SquareCheckboxIcon checked />}
            />
          }
          label={
            <Typography
              variant={'caption'}
              sx={{
                fontWeight: 400,
                fontSize: '14px',
                '&:first-letter': {
                  textTransform: 'capitalize',
                },
              }}
            >
              {label}
            </Typography>
          }
          sx={{
            padding: 0,
            margin: 0,
            gap: '8px',
            width: '100%',
            alignItems: 'center',
          }}
        />
      )}
    />
  );
};

export default CheckBox;
